import { FC } from 'react';
import { Typography } from '@mui/material';
import {
  helpCenterCategoryItem,
  helpCenterCategoryItemActive
} from './HelpCenterCategoryItem.styles';

interface HelpCenterCategoryItemProps {
  onClick: () => void;
  active: boolean;
  label: string;
}

export const HelpCenterCategoryItem: FC<HelpCenterCategoryItemProps> = ({
  onClick,
  active,
  label
}) => {
  return (
    <Typography
      onClick={onClick}
      sx={[helpCenterCategoryItem, active && helpCenterCategoryItemActive]}
    >
      {label}
    </Typography>
  );
};
